// --------------------------------------------------------
//  Class for exporting data to desktop through Electron.
// --------------------------------------------------------

import fs from 'fs'; // file system operations from node.js
import fb from '@/shift/fb';
import agile from '@/shift/agile';
import taffelTemplates from '@/shift/exportlegacy/taffelTemplates';

const agileElectron =
{
	app: null,
	alert: null,
	key: '',
	folderPath: '',
	treeItems: null,
	treeOrphans: null,
	contentString: '',
	contentIndex: 0,
	classNames: [],
	contentForJsonFiles: [],

	// ----------------------------------
	//	Set some custom layout sizes
	// ----------------------------------

	startExport()
	{
		if (!this.app) { console.log('* No electron js'); return; }

		console.log('Starting, key:', this.key);
		
		this.treeItems = [];
		this.treeOrphans = [];
		this.contentString = '';
		this.contentIndex = 0;
		this.classNames = [];
		this.contentForJsonFiles = [];


		const contentCollection = fb.db
			.collection('content-collection')
			.doc('content-doc')
			.collection(this.key)
			.doc(this.key)
			.collection('content').where("trash", "==", false);


		// Gogogo, go live
		this.unsubscribeLiveContent = contentCollection.get()
		.then(querySnapshot =>
		{
			querySnapshot.forEach((doc) =>
			{
				// Build tree structure
				const docData = doc.data();
				docData.id = doc.id;
				//docData.doc = doc; // This sucks, back-referenceing this. Oh well... fix in the future
				docData.nodeType = (docData.sharedContent) ? 'shared-content' : 'content' ;
				docData.children = [];

				this.insertInTree(docData);
			});

			this.prepareForSaving();

		})
		.catch(er =>
		{
			this.$alert('Error getting firebase 1', er.message);
		});
	},


	prepareForSaving()
	{
		this.cleanTreeData(this.treeItems);
		this.buildLegacyStructure();
	},


	saveStructure()
	{
		if (!this.app) { console.log('* No electron js'); return; }
		
		let fixedFolderPath = this.folderPath.replace(/[\\]+/g, '/');
		if (fixedFolderPath.substr(fixedFolderPath.length-1) !== '/') fixedFolderPath = fixedFolderPath+"/";
		
		// You need to save the filepath when you open the file to update without use the filechooser dialog againg
		var filepath = fixedFolderPath+"angular.module.js";
		//const jsonData = JSON.stringify(this.contentString);

		/* for (let i = 0; i < this.contentForJsonFiles.length; i++)
		{
			console.log('---------------');
			console.log(this.contentForJsonFiles[i].content);
		}
		filepath; fs; */
		fs.writeFile(filepath, this.contentString, (err) =>
		{
			if (err)
			{
				alert("An error ocurred updating the file" + err.message);
				console.log(err);
				return;
			}

			for (let i = 0; i < this.contentForJsonFiles.length; i++)
			{
				fs.writeFile(fixedFolderPath+'data/pages/'+this.contentForJsonFiles[i].id+'.json', this.contentForJsonFiles[i].content, (err) =>
				{
					if (err)
					{
						alert("An error ocurred updating the file" + err.message);
						console.log(err);
						return;
					}

					console.log('* Saved', this.contentForJsonFiles[i].id);
				});
			}

			//alert("The file has been succesfully saved");
			//this.buildLegacyContentFiles();
		});
		
	},


	buildLegacyContentFiles()
	{
		
		for (let i = 0; i < this.contentForJsonFiles.length; i++)
		{
			//
		}

	},



	appendContentForJsonFiles(id, title)
	{
		this.contentForJsonFiles.push(
			{
				id: id,
				content: //JSON.stringify(
`{
	"id": "${id}",
	"shared": false,
	"title": "${title}"
}`,
				//),
			}
		);
	},



	buildLegacyStructure()
	{

		this.contentString = taffelTemplates.angularModule1;
		
		// ----------------------------------------------------
		//	Make root entry
		// ----------------------------------------------------

		this.rootId = this.treeItems[0].id;

		this.contentString = this.contentString+this.getLegacyRootEntry(
			this.treeItems[0].id,								// id
			this.treeItems[0].editorMetaData.treeNodeLabel,		// title
			this.treeItems[0].editorMetaData.templateClass		// className
		);

		this.appendClassName(this.treeItems[0].editorMetaData.templateClass);
		this.appendContentForJsonFiles(this.treeItems[0].id, this.treeItems[0].editorMetaData.treeNodeLabel);
		

		// ----------------------------------------------------
		//	Make route elements
		// ----------------------------------------------------
		
		this.contentIndex = 1;
		this.appendLegacyRouteObjects(this.treeItems[0].children, this.contentIndex, this.treeItems[0].editorMetaData.templateClass);
		
		this.contentString += '\r\r\r';

		// ----------------------------------------------------
		//	Push route elements
		// ----------------------------------------------------
		
		for (let i = 0; i < this.contentIndex; i++)
		{
			this.contentString = this.contentString+`taffelContentList.push(taffelContent${i});
`;
		}
		


		this.contentString = this.contentString+taffelTemplates.angularModule2;



		// ----------------------------------------------------
		//	Add states
		// ----------------------------------------------------
		
		for (let i = 0; i < this.contentIndex; i++)
		{
			this.contentString = this.contentString+`
		.state(taffelContent${i})`;
		}
		
		this.contentString = this.contentString+taffelTemplates.angularModule3;

				
		// ----------------------------------------------------
		//	Add requires
		// ----------------------------------------------------

		for (let i = 0; i < this.classNames.length; i++)
		{
			const lowerCaseClass = this.classNames[i].toLowerCase();//lowerCaseClass
			this.contentString = this.contentString+`require("../02 Source/pages/${lowerCaseClass}/${lowerCaseClass}");
`;
		}
		
		this.saveStructure();
	},


	appendLegacyRouteObjects(items)
	{
		if (Array.isArray(items))
		{
			for (let i = 0; i < items.length; i++)
			{
				let view;

				switch (items[i].editorMetaData.templateClass)
				{
					case 'Launcher': view = 'body@root'; break;
					case 'VideoPage': view = 'body@root'; break;
					case 'SidePanel': view = 'sidePanel@root'; break;
					case 'ScrollContent': view = 'scrollContent'; break;
					default: view = 'body@root'; break;
				}
				
				const theParentFix = (items[i].parent === this.rootId) ? 'root' : items[i].parent ;

				this.contentString = this.contentString+this.getEntry(
					this.contentIndex,							// index
					items[i].slug,								// slug
					items[i].parent,							// parent id
					items[i].id,								// id
					items[i].editorMetaData.treeNodeLabel,		// title
					items[i].editorMetaData.templateClass,		// className
					items[i].contentMetaData.mainMenuMember,	// mainMenuMember
					items[i].contentMetaData.breadcrumbMember,	// breadcrumbMember
					view,										// view
					theParentFix								// Fix parent thing
				);
				
				this.appendClassName(items[0].editorMetaData.templateClass);
				this.appendContentForJsonFiles(items[i].id, items[i].editorMetaData.treeNodeLabel);

				this.contentIndex++;

				// Check nested children
				if (items[i].children && items[i].children.length > 0) this.appendLegacyRouteObjects(items[i].children);
			}
		}
	},



	appendClassName(className)
	{
		for (let i = 0; i < this.classNames.length; i++)
		{
			if (this.classNames[i] === className) return;
		}
		this.classNames.push(className);
	},








	getLegacyRootEntry(id, title, className)
	{
		const lowerCaseClass = className.toLowerCase();

		return `

var taffelContent0 = { name: "root", url: "/", id: "${id}", title: "${title}",
	Icon: "default",
	TitleFormatted: "",
	NaviMember: "false",
	ShowInMenu: "true",
	BreadcrumbMember: "true",
	resolve:
	{
		data:function($http)
		{
			return $http.get("./data/pages/${id}.json");
		},
		stateName: function() { return "root"; }
	},
	views:
	{
		"":
		{
			templateUrl: "./pages/root.html"
		},
		"background@root":
		{
			templateUrl: "./pages/background/background.html",
			controller: "BackgroundController"
		},
		"foreground@root":
		{
			templateUrl: "./pages/foreground/foreground.html",
			controller: "ForegroundController"
		},
		"body@root":
		{
			templateUrl: "./pages/${lowerCaseClass}/${lowerCaseClass}.html",
			controller: "${className}Controller"
		}
	}
};`
	},



	getEntry(index, slug, parent, id, title, className, mainMenuMember, breadcrumbMember, view, parent2) // body$root
	{
		const lowerCaseClass = className.toLowerCase();

		return `
		
var taffelContent${index} = { name: "${id}", url: "${slug}/",	parent: "${parent2}",	parentId: "${parent}",	id: "${id}", title: "${title}",
	TitleFormatted: "",
	NaviMember: "false",
	Icon: "default",
	Description: "",
	ShowInMenu: "${mainMenuMember}",
	BreadcrumbMember: "${breadcrumbMember}",
	NotMobileMenuChild: "false",
	LauncherImage: "",

	resolve:
	{
		data:function($http)
		{
			return $http.get("./data/pages/${id}.json");
		},
		stateName: function() { return "${id}"; }
	},
	views:
	{
		"${view}":
		{
			templateUrl: "./pages/${lowerCaseClass}/${lowerCaseClass}.html",
			controller: "${className}Controller"
		}
	}
};`
	},













	cleanTreeData(items)
	{
		if (Array.isArray(items))
		{
			for (let i = 0; i < items.length; i++)
			{
				items[i].parent = (!items[i].parentItem) ? false : items[i].parentItem.id ;
				
				delete items[i].parentItem;
				delete items[i].trash;
				delete items[i].visibility;
				delete items[i].nodeType;

				delete items[i].editorMetaData.templateId;
				delete items[i].editorMetaData.treeNodeParent;

				delete items[i].contentMetaData.breadcrumbMemberOverridable;
				delete items[i].contentMetaData.depthOverridable;
				delete items[i].contentMetaData.enableSeoOverridable;
				delete items[i].contentMetaData.exposeEditableBreadcrumb;
				delete items[i].contentMetaData.exposeIconFrontEndToEditor;
				delete items[i].contentMetaData.iconEditor;
				delete items[i].contentMetaData.iconFrontEndOverridable;
				delete items[i].contentMetaData.mainMenuMemberOverridable;
				delete items[i].contentMetaData.preloadFlowOverridable;
				delete items[i].contentMetaData.showInSearchOverridable;
				delete items[i].contentMetaData.subMenuMemberOverridable;
				delete items[i].contentMetaData.useIconsInFrontEnd;
				delete items[i].contentMetaData.useSameIconsAsInEditorInFrontEnd;
				delete items[i].contentMetaData.enableSeo;
				

				// Check nested children
				if (items[i].children && items[i].children.length > 0) this.cleanTreeData(items[i].children);
			}
		}
	},



	// -------------------------------------------------------------------------
	//
	//	Build dataprovider for treeview, with nodes supplied from Firestore!
	//	This function is copied from ContentEditorTree.vue !
	//
	// -------------------------------------------------------------------------

	insertInTree(item)
	{
		if (!item.editorMetaData.treeNodeParent) item.editorMetaData.treeNodeParent = 'root'; // if item has no parent, make root it's parent
		
		if (item.editorMetaData.treeNodeParent === 'root')
		{
			item.parentItem = 'root';
			this.treeItems.push(item);
		}
		else
		{				
			const parent = agile.getObjectById(this.treeItems, item.editorMetaData.treeNodeParent);
			
			// We have no idea in which order we are receiving the tree items, so parent nodes might not
			// be built yet.
			if (parent)
			{
				
				// If we find the parent, store the item there
				if (!parent.children) // Parent doesnt accept children, put the node to root instead as safety solution
				{
					item.parentItem = 'root';
					this.treeItems.push(item);
				}
				else
				{
					
					item.parentItem = parent;
					parent.children.push(item);
				}
				
			}
			else
			{
				// If not, store it in orphans, and we will see if we find parent later
				this.treeOrphans.push(item);
			}
			
		}


		// Now check the orphans. Maybe our new item is parent to some orphaned item
		for (let i = this.treeOrphans.length-1; i >= 0; i--)
		{
			if (this.treeOrphans[i].editorMetaData.treeNodeParent === item.id)
			{
				if (!item.children)
				{
					console.log(`* Tree builder is trying to add treenode to parent that has no "children" object. Adding to root instead (${this.treeOrphans[i].editorMetaData.treeNodeLabel}).`);
					this.treeOrphans[i].parentItem = 'root';
					this.treeItems.push(this.treeOrphans[i]);
				}
				else
				{
					this.treeOrphans[i].parentItem = item;
					item.children.push(this.treeOrphans[i]);
				}

				// Ok, we have sorted that this is not an orphan anymore, take it out of orphan list
				this.treeOrphans.splice(i, 1);
			}
		}


		// Now we really check on behalf of the orphans. Do they have parents or not?

		let lastCount = 0;
		let currentCount = this.treeOrphans.length;

		while (lastCount !== currentCount) // Check until there are no possible parents for orphans
		{
			for (let i = this.treeOrphans.length-1; i >= 0; i--)
			{
				const checkItem = this.treeOrphans[i];
				const checkItemParent = agile.getObjectById(this.treeItems, checkItem.editorMetaData.treeNodeParent);
				
				

				if (checkItemParent)
				{
					// If we find the parent, store the item there
					if (!checkItemParent.children) // Parent doesnt accept children, put the node to root instead as safety solution
					{
						checkItem.parentItem = 'root';
						this.treeItems.push(checkItem);
					}
					else
					{		
						checkItem.parentItem = checkItemParent;
						checkItemParent.children.push(checkItem);
					}
					this.treeOrphans.splice(i, 1);
				}
			}

			lastCount = currentCount;
			currentCount = this.treeOrphans.length;
		}


		// Update sort order children arrays
		agile.updateTreeSortOrder(this.treeItems, this.treeOpenNodes);
		
		
	},







	
	


};



export default agileElectron;